import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import ZaroPayQR from "./ZaroPayQR.jsx"
import { ZaropayDepositAmountApi } from '../../../../../api/request/wallet/deposit.js';
// tncFileUrl will be passed as a prop
import { handleApiError } from '../../../../../utils/handleApiError.js';
import { getDepositAmountError } from '../../../../../utils/validateDepositAmount.js';

const ZaroPay = ({ amount, paymentMethod, loginTerminalId, resetAll, validateAmount, tncFileUrl }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isDepositLoading, setIsDepositLoading] = useState(false);
    const [depositdata, setDepositdata] = useState(null);
    const [step, setStep] = useState(1);

    const handleSubmit = async (values) => {
        setIsDepositLoading(true);
        try {
            const amountError = validateAmount || getDepositAmountError(amount, paymentMethod);
            if (amountError) {
                toast.error(amountError);
                return;
            }
            const isWallet = loginTerminalId === 'wallet';
            const deposiParams = {
                userId: userDetails?._id,
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                loginTerminalId: isWallet ? 0 : loginTerminalId,
            };
            const { data } = await ZaropayDepositAmountApi(deposiParams);
            if (data?.success) {
                form.resetFields();
                setDepositdata(data?.data);
                setStep(2);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsDepositLoading(false);
        }
    };

    return (
        <div>
            {step === 1 && (
                <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the{' '}
                            {tncFileUrl && (
                                <a href={tncFileUrl} target="_blank" rel="noopener noreferrer" className="primary underline hover:underline duration-300">Terms & Conditions</a>
                            )}
                        </Checkbox>
                    </Form.Item>

                    <LoadableButton
                        className='block bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                        type="submit"
                        lable='Next'
                        isLoading={isDepositLoading}
                    />
                </Form>
            )}

            {step === 2 && (
                <ZaroPayQR depositdata={depositdata} resetAll={resetAll} />
            )}
        </div>
    )
}

export default ZaroPay
